import { Button } from "@istari-frontend/ui";

import { IstariDigitalLogo } from "~/assets/svg";
import { adminContact } from "~/utils/admin-contact";

import { noAccessCopy, type NoAccessReason } from "../model/no-access";

export type NoAccessScreenProps = { reason: NoAccessReason; onSignOut: () => void };

/** Full-page view for a sign-in that has nothing to open; rendered without the app shell. */
export function NoAccessScreen({ reason, onSignOut }: NoAccessScreenProps) {
  const contact = adminContact();
  return (
    <div className="bg-background text-foreground flex min-h-svh w-full justify-center">
      <div className="mt-12 flex w-[420px] max-w-[90%] flex-col items-center gap-6 text-center">
        <IstariDigitalLogo height="40px" />
        <h1 data-testid="no-access-heading" className="text-2xl font-bold">
          {reason === "deactivated" ? "Your account is suspended" : "You don't have access to Istari yet"}
        </h1>
        <p className="text-muted-foreground text-sm">{noAccessCopy[reason]}</p>
        <p className="text-sm">
          Contact your administrator
          {contact ? (
            <>
              : <ContactLink contact={contact} />
            </>
          ) : (
            "."
          )}
        </p>
        <Button data-testid="no-access-sign-out" onClick={onSignOut}>
          Sign out
        </Button>
      </div>
    </div>
  );
}

function ContactLink({ contact }: { contact: string }) {
  const linkClassName = "text-primary underline-offset-4 hover:underline";
  if (contact.includes("@")) {
    return (
      <a data-testid="no-access-contact" href={`mailto:${contact}`} className={linkClassName}>
        {contact}
      </a>
    );
  }
  if (/^https?:\/\//i.test(contact)) {
    return (
      <a
        data-testid="no-access-contact"
        href={contact}
        target="_blank"
        rel="noopener noreferrer"
        className={linkClassName}
      >
        {contact}
      </a>
    );
  }
  return <span data-testid="no-access-contact">{contact}</span>;
}
